import { Injectable, signal } from '@angular/core';
import { MeetingReminder } from '../models/meeting-reminder.model';

@Injectable({
  providedIn: 'root',
})
export class BrowserNotificationService {
  readonly permission = signal<NotificationPermission>(typeof Notification !== 'undefined' ? Notification.permission : 'denied');

  async requestPermission(): Promise<NotificationPermission> {
    if (!('Notification' in window)) {
      console.error('This browser does not support desktop notification');
      return 'denied';
    }
    const permission = await Notification.requestPermission();
    this.permission.set(permission);
    return permission;
  }

  async show(reminder: MeetingReminder): Promise<void> {
    let currentPermission = this.permission();
    if (currentPermission === 'default') {
      currentPermission = await this.requestPermission();
    }

    if (currentPermission === 'granted') {
      const title =
        reminder.reminderType === 'START' ? `Start Live Assistant: ${reminder.meetingSummary}` : `Stop Live Assistant: ${reminder.meetingSummary}`;
      const notification = new Notification(title, {
        body: reminder.reminderType === 'START' ? 'Your meeting is starting...' : 'Your meeting has ended...',
        icon: 'assets/logo.png',
        requireInteraction: true,
      });
      notification.onclick = () => window.focus();
    } else {
      console.warn('Notification permission has not been granted.');
    }
  }
}
